import React from 'react';
import { NumberInputRow } from '@/components/form/NumberInputRow';
import { AnimatedFormError } from '@/components/form/AnimatedFormError';
import { CustomizedFieldIndicator } from '../../../form/CustomizedFieldIndicator';


interface Props {
  fixedSurchargeAmountProps?: Record<string, unknown>;
  fixedSurchargeAmountError?: React.ReactNode;
  customizedFields: Record<string, boolean>;
  context: 'user' | 'client';
}

export const FixedDollarSection: React.FC<Props> = ({
  fixedSurchargeAmountProps,
  fixedSurchargeAmountError,
  customizedFields,
  context,
}) => {
  return (
    <div className="space-y-4">
      <NumberInputRow
          id="holiday-fixed-premium-amount"
          label={
            <div className="flex items-center gap-1.5">
              <span>Fixed Premium Amount</span>
              <CustomizedFieldIndicator isCustomized={customizedFields.holiday_fixed_premium_amount} context={context} />
            </div>
          }
          description="Straight time rate calculations plus a flat dollar premium."
          unit="$"
          unitPosition="left"
          inputProps={fixedSurchargeAmountProps ?? {}}
          errorElement={<AnimatedFormError>{fixedSurchargeAmountError}</AnimatedFormError>}
        />
    </div>
  );
};
